<div class="zk-flex zk-items-end zk-gap-2 zk-w-full" [formGroup]="dates.controls[index]">
	<freud-calendar
		ngDefaultControl
		[label]="'APPOINTMENTS.DATE' | translate"
		[inline]="false"
		formControlName="date"
		[showTime]="false"
		[minDate]="minDate"
		(onSelect)="onChangeDate.emit({ event: $event, index: this.index })"
		class="date-input zk-w-3/5"
	></freud-calendar>
	<freud-calendar
		ngDefaultControl
		[label]="'APPOINTMENTS.TIME' | translate"
		[timeOnly]="true"
		[minDate]="minDate"
		(onSelect)="onChangeTime.emit($event)"
		formControlName="time"
		[stepMinute]="10"
		[inline]="false"
		class="time-input zk-w-2/5"
	></freud-calendar>
	<freud-button
		class="date__remove-button"
		color="secondary"
		*ngIf="dates.controls.length > 1 && index > 0"
		size="sm"
		(click)="onRemove.emit(index)"
		><span class="freud-icon freud-icon-sm freud-icon-times"></span
	></freud-button>
</div>
